export default "__VITE_ASSET__CZs6JhbS__"